/**
 * Detects iOS in-app browsers (bare WKWebViews inside mail/social apps),
 * where the native camera picker opens with a black preview because the
 * host app never requested camera permission. When detected, reveals a
 * warning banner with an escape hatch to a real browser.
 *
 * Third-party browsers hit the same black preview when the browser app
 * itself lacks camera permission; that case is handled by
 * CameraPermissionHint.
 */

import { isIosInAppBrowser } from "./ios";

const InAppBrowserWarning = {
  mounted() {
    const detected = isIosInAppBrowser();

    // Report the verdict server-side so support tickets ("camera is
    // black but no banner showed") can be diagnosed from the logs.
    this.pushEvent("browser_env", {
      ua: navigator.userAgent,
      in_app_detected: detected,
    });

    if (!detected) return;

    this.el.classList.remove("hidden");

    const openBtn = this.el.querySelector("[data-open-browser]");
    const copyRow = this.el.querySelector("[data-copy-fallback]");
    const copiedNote = this.el.querySelector("[data-copied-note]");

    openBtn?.addEventListener("click", () => {
      const url = window.location.href;

      // Breaks out to Safari from some in-app browsers; silently ignored
      // by hosts that block custom schemes, so also arm the fallback.
      window.location.href = "x-safari-" + url;

      setTimeout(() => {
        if (document.visibilityState === "visible") {
          openBtn.classList.add("hidden");
          copyRow?.classList.remove("hidden");
        }
      }, 1500);
    });

    copyRow?.querySelector("[data-copy-link]")?.addEventListener("click", () => {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => copiedNote?.classList.remove("hidden"))
        .catch(() => {});
    });
  },
};

export default InAppBrowserWarning;
